import React, { useEffect, useState, FC, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';
import type { Location, Params, NavigateFunction  } from 'react-router-dom';

import { customername } from '../../../index';
import { ErrorFallback } from './ErrorFallback';
import { usePrevious, withRouter } from '@/hooks';

export interface ErrorBoundaryProps {
  router: {
    location: Location;
    navigate: NavigateFunction;
    params: Params;
  };
  children: ReactNode
}
const ErrorBoundary: FC<ErrorBoundaryProps> = (props) => {
  const [hasError, setHasError] = useState(false);
  const prevPathname = usePrevious(props.router.location.pathname);

  useEffect(() => {
    if(props.router.location.pathname !== prevPathname && hasError) {
      setHasError(false);
    }
  }, [props.router.location.pathname, prevPathname, hasError]);

  const handleError = (error: Error) => {
    setHasError(true);
    Sentry.withScope((scope) => {
      const [customer] = customername.split('/');
      scope.setExtras({ customer });
      Sentry.captureException(error);
    });
  };

  return  <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
    {props.children}
  </ReactErrorBoundary>;
};

export default withRouter(ErrorBoundary);
